import { useEffect, useState } from "react";
import { includes } from "lodash";
import { toast } from "react-toastify";
import { tractorEditableColumns } from "../../../../services/authorizationService";
import { dispatcher } from "../../../../store/storeHelpers";
import { getValueOrDash } from "../../../../utils/helpers";
import * as actionType from "../../../../store/ActionTypes";
import AsyncSelectField from "../../inputs/AsyncSelectField";
import { getPortList } from "../../../../services/dataService";
import { getUser } from "../../../../services/authService";
import {
	updateTractorShipment,
	uploadTractorBookingDocument,
	viewSIDoc,
} from "../../../../services/tractorDataService";
import { Button } from "react-bootstrap";
import pdfIcon from "../../../../assets/icons/pdfIcon.png";
import Select from "react-select";
import moment from "moment";
import { updateBookingNumTractor } from "../../../../services/tractorDataService";
import Tooltips from "../../../Custom Components/tooltip";
import { getDailyContainerPlanningAB } from "../../../../services/tractorDataService";
import { tractorDataCreatorForStore } from "../../../../utils/dataFilter";
import * as actionTypes from "../../../../store/ActionTypes";

const ContainerChangeModuleEditable = ({
	value: initialValue,
	row: { original, subRows },
	column: { id },
	transporterList,
	showDisableCellForJD,
	setShowDisableCellForJD,
	newSelectedFlatRows,
	allowToEdit,
	date,
	tableData,
	data,
	dataType,
}) => {
	const [value, setValue] = useState(initialValue);
	const [typing, setTyping] = useState(false);

	const user = getUser();

	useEffect(() => {
		if (includes(user.role, "jd_team")) {
			setShowDisableCellForJD(true);
		}
	}, [user, setShowDisableCellForJD]);

	const onChange = (e) => {
		setValue(e.target.value);
		
  
		setTyping(true);
    
	};

	const containerType = [
		{ value: "Tractor", label: "Tractor" },
		{ value: "Aggregate", label: "Aggregate" },
		{ value: "5M", label: "5M" },
	];
	const onBlur = () => {
		original[id] = value;
	};



	useEffect(() => {
		setValue(initialValue);
	}, [initialValue]);
	if (id === "Date") {
		return (
			<Tooltips content={value} direction="left" typing={typing}>
				<div>
      
					<input
						type="date"
						className="table_input"
						style={{ textAlign: "left" }}
						defaultValue={value}
						onChange={onChange}
						onBlur={onBlur}
						name={id}
            required
						//   disabled={showDisableCellForJD || !allowToEdit}
					/>
				</div>
			</Tooltips>
		);
	}
	if (id === "Country") {
		return (
			<Tooltips content={value} direction="left" typing={typing}>
				<div>
					<input
						type="text"
						className="table_input"
						style={{ textAlign: "left" }}
						value={value}
						onChange={onChange}
						onBlur={onBlur}
						name={id}
						disabled={true}
						//   disabled={showDisableCellForJD || !allowToEdit}
					/>
				</div>
			</Tooltips>
		);
	}
	if (id === "Market") {
		return (
			<Tooltips content={value} direction="left" typing={typing}>
				<div>
       
					<input
						type="text"
						className="table_input"
						style={{ textAlign: "left" }}
						value={value}
						onChange={onChange}
						onBlur={onBlur}
						name={id}
						disabled={true}
            
						//   disabled={showDisableCellForJD || !allowToEdit}
					/>
				</div>
			</Tooltips>
		);
	}
	if (id === "Module_Type") {
    
		return (

      <div>
			<Select
				options={containerType?.filter(item => value ? item.label !== value : item.label !== dataType )}
				menuPortalTarget={document.body}
				styles={{
					menuPortal: (base) => ({ ...base, zIndex: 9999 }),
					width: "100%",
				}}
				placeholder="Select..."
				className="Container_Type_dropdown new-width"
				maxMenuHeight={90}
				name="Container_Type"
				value={value ? {label:value} : {label:dataType}}
				onBlur={onBlur}
				onChange={(option) => setValue(option["label"])}
				//   isDisabled={showDisableCellForJD || !allowToEdit}
      
			/>
      </div>
		);

	} else return `${getValueOrDash(value)}`;
};

export const defaultColumn = {
	Cell: ContainerChangeModuleEditable,
	//   updatedfield:
};
